import { makeStyles, Grid } from '@material-ui/core'
import React from 'react'

import TeamMemberCard from '@aletheia/common/components/Team/TeamMemberCard'
import { isEntry } from '@aletheia/common/lib/contentful/types'
import { getEntry } from '@aletheia/common/lib/contentful/utils'
import { IFund } from '@aletheia/eafunds/contentful'

const useStyles = makeStyles((theme) => ({
  teamMemberContainer: {
    marginBottom: theme.spacing(4),
  },
  teamMemberWrapper: {
    display: 'flex',
    alignItems: 'stretch',
  },
  bodyMarkdown: {
    '& *': {
      fontFamily: theme.typography.h1.fontFamily,
    },
  },
}))

type FundManagersProps = { Fund: IFund['fields'] }

export const Advisors: React.FC<FundManagersProps> = ({ Fund }) => {
  const classes = useStyles()
  return (
    <Grid container spacing={2} className={classes.teamMemberContainer}>
      {Fund.advisors?.filter(isEntry).map((Person) => (
        <Grid
          item
          xs={12}
          md={6}
          key={Person.sys.id}
          className={classes.teamMemberWrapper}
        >
          <TeamMemberCard
            Person={Person}
            Organization={getEntry(Person.fields.organization)}
            longJobTitle={`${Fund.title} Fund Advisor`}
            jobTitle={`Fund Advisor`}
          />
        </Grid>
      ))}
    </Grid>
  )
}
